import React from 'react';

/**
 * A labelled group inside a breakdown: a small caption over a tinted panel of
 * rows or steps.
 *
 * Two shapes, both already in use:
 *  - with `bodyClassName` — caption + panel (the emission-factor, SEFA and
 *    calculation groups);
 *  - without it — the children sit directly in the wrapper, which is how the
 *    ruled footer of inputs is built.
 *
 * @param {Object} props
 * @param {React.ReactNode} [props.title] - already translated by the caller
 * @param {React.ReactNode} [props.titleSuffix] - rendered inside the caption,
 *   after the title (a chip, a year, a reporting period)
 * @param {string} [props.className] - the wrapper's classes
 * @param {string} [props.titleClassName] - the caption's classes
 * @param {string} [props.bodyClassName] - the panel's classes; omit for no panel
 * @param {React.ReactNode} props.children
 */
export default function CgBreakdownSection({
  title,
  titleSuffix,
  className = 'space-y-1',
  titleClassName = 'text-xs font-medium text-gray-700',
  bodyClassName,
  children,
}) {
  return (
    <div className={className}>
      {(title !== undefined || titleSuffix !== undefined) && (
        <p className={titleClassName}>
          {title}
          {titleSuffix}
        </p>
      )}
      {bodyClassName ? <div className={bodyClassName}>{children}</div> : children}
    </div>
  );
}
